
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/anfitrion/blog/[slug]",
      function () {
        return require("private-next-pages/anfitrion/blog/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/anfitrion/blog/[slug]"])
      });
    }
  